module.exports = __webpack_public_path__ + "static/media/relationship_child.0403b20d.svg";